var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M15.417 2.872H4.583C2.053 2.875.003 4.925 0 7.455v.834c0 .23.187.416.417.416h19.166c.23 0 .417-.186.417-.416v-.834c-.003-2.53-2.053-4.58-4.583-4.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72C1FE",
    d: "M17.04 5.602l-1.765-3.528C14.555.634 12.803.049 11.362.769l-.078.04L2.72 5.422c-.202.11-.278.363-.169.565.073.135.214.219.367.219h13.75c.23 0 .416-.187.416-.417 0-.065-.015-.129-.044-.187v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M2.917 5.372h14.166C18.694 5.372 20 6.678 20 8.29v8.333c0 1.61-1.306 2.917-2.917 2.917H2.917C1.306 19.539 0 18.233 0 16.622V8.29c0-1.611 1.306-2.917 2.917-2.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M19.583 9.54H16.25c-1.61 0-2.916 1.306-2.915 2.917 0 1.61 1.305 2.915 2.915 2.915h3.333c.23 0 .417-.186.417-.416v-5c0-.23-.187-.417-.417-.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M16.25 13.706c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H20V20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.5d2deec2.svg";
export { ForwardRef as ReactComponent };